import { render, staticRenderFns } from "./AdminHospitalPerformanceStatistics.vue?vue&type=template&id=2739724e&scoped=true"
import script from "./AdminHospitalPerformanceStatistics.vue?vue&type=script&lang=js"
export * from "./AdminHospitalPerformanceStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2739724e",
  null
  
)

export default component.exports